import { ChangeDetectionStrategy, Component } from '@angular/core';
import { makeTooltipProvider } from '../../../../cross-team-shared/tooltips/tooltip-utils';
import { MainVectorTaggingToolbarComponent } from '../../../shared/toolbars/main-toolbars/main-vector-tagging-toolbar.component';

@Component({
  selector: 'h3-main-video-toolbar-objectless',
  templateUrl:
    '../../../shared/toolbars/abstract-main-toolbar/abstract-main-toolbar-2d.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [makeTooltipProvider({ position: 'right' })],
  standalone: false,
})
export class MainVideoToolbarComponent extends MainVectorTaggingToolbarComponent {}
